export const environment = {
  production: false,
  _url: 'https://apiqas.brisar.net',
};
